export * from "./ISlideSearchDocument";
